import {
    ITpayPayload,
    ITpayRedirectSubscribeNewUserEntity,
    ITpayRedirectSubscribeNewUserReqBody,
} from '../../../entity/interface/iTPayRedirectSubscribe';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
export interface ITpayRedirectSubscribeNewUseCase {
    execute(
        username: string,
        msisdn: string,
        tpay: ITpayPayload,
        reqBody: ITpayRedirectSubscribeNewUserReqBody
    ): Promise<ITpayRedirectSubscribeNewUserEntity>;
}

export class TpayRedirectSubscribeNewUseCase implements ITpayRedirectSubscribeNewUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        username: string,
        msisdn: string,
        tpay: ITpayPayload,
        reqBody: ITpayRedirectSubscribeNewUserReqBody
    ): Promise<ITpayRedirectSubscribeNewUserEntity> {
        return await this.subscriptionRepository.tpayRedirectSubscribeNew(username, msisdn, tpay, reqBody);
    }
}
